<template>
  <div class="page page-user-edit">
    <van-notice-bar
      color="#1989fa"
      background="#ecf9ff"
      wrapable
      :scrollable="false"
      left-icon="info-o"
    >
      请如实填写相关内容，蓝色字段属于可以维护的内容，您可视实际情况填写
    </van-notice-bar>
    <van-form @submit="handleClickSubmit">
      <van-cell-group class="app-card">
        <van-field
          class="readonly"
          label-align="left"
          v-model="userInfo.name"
          label="姓名"
          placeholder="未录入"
          :readonly="true"
        />
        <van-field
          class="readonly"
          v-model="userInfo.companyName"
          :readonly="true"
          label="入职单位"
          placeholder="未录入"
        />
        <van-field
          class="readonly"
          v-model="userInfo.idCard"
          :readonly="true"
          label="身份证号码"
        />
        <van-field
          name="radio"
          label="证件有效期类型"
          :rules="[{ required: true, message: '请选择' }]"
        >
          <template #input>
            <van-radio-group
              v-model="userInfo.idCardEndType"
              direction="horizontal"
            >
              <van-radio name="固定">固定</van-radio>
              <van-radio v-if="isAgeGreaterThan45" name="长期">长期</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <template v-if="userInfo.idCardEndType === '固定'">
          <date-field
            v-model="userInfo.idCardStart"
            label="证件有效期起"
            :min-date="minIdCardDate"
            required
          />
          <date-field
            v-model="userInfo.idCardEnd"
            label="证件有效期至"
            :min-date="minIdCardDateEnd"
            :max-date="maxIdCardDateEnd"
            required
            :placeholder="
              userInfo.idCardStart ? '未选择' : '请先选择证件起始有效期'
            "
            :disabled="!userInfo.idCardStart"
          />
        </template>
        <van-field
          left-icon="question"
          @click-left-icon="
            showHelp('若变更手机号，需提供登录密码 和 短信验证码')
          "
          maxlength="11"
          type="digit"
          v-model="userInfo.mobile"
          center
          clearable
          label="手机号"
          placeholder="请输入手机号"
          :rules="[{ required: true, message: '请输入' }]"
        />
        <template
          v-if="
            (userInfo.mobile !== sourceInfo.mobile || !sourceInfo.mobile) &&
            userInfo.mobile &&
            userInfo.mobile.length === 11
          "
        >
          <van-field
            v-model="userInfo.mobileCode"
            maxlength="11"
            type="digit"
            center
            clearable
            label="短信验证码"
            placeholder="请输入短信验证码"
          >
            <template
              #button
              v-if="userInfo.mobile !== sourceInfo.mobile || !sourceInfo.mobile"
            >
              <van-button
                size="small"
                type="primary"
                @click="getMobileCode"
                :disabled="!userInfo.mobile || sendCountDown > 0"
              >
                发送验证码
                <span v-if="sendCountDown">({{ sendCountDown }})</span>
              </van-button>
            </template>
          </van-field>
          <van-field
            v-model="userInfo.mobilePassword"
            center
            clearable
            label="登录密码"
            placeholder="请输入登录密码"
          ></van-field>
        </template>
        <sys-dict
          v-model="userInfo.xueliTypeMax"
          dict-name="xueliTypeMax"
          label="最高学历"
          required
        />
        <sys-dict
          v-model="userInfo.zhicheng"
          dict-name="zhicheng"
          label="职称"
          required
        />
        <van-field
          v-model="userInfo.zhichengCate"
          v-if="userInfo.zhicheng && userInfo.zhicheng !== '无'"
          clearable
          label="申报职称专业"
          placeholder="请填写申报职称专业"
          :rules="[{ required: true, message: '请输入' }]"
        />
        <sys-dict
          v-model="userInfo.gangwei"
          dict-name="gangwei"
          label="岗位"
          required
        />
        <van-field
          v-if="userInfo.gangwei === '其他'"
          v-model="userInfo.gangweiOther"
          center
          clearable
          label="请输入岗位"
          placeholder="请输入岗位"
          required
        />
        <sys-dict
          v-model="userInfo.isCanji"
          dict-name="isCanji"
          label="是否有残疾证"
          :readonly="sourceInfo.isCanji"
          :class="{ readonly: sourceInfo.isCanji }"
          required
        />
        <van-field
            v-if="userInfo.isCanji && userInfo.isCanji !== '无' && userInfo.isCanji !== '否'"
          v-model="userInfo.canjiCard"
          label="残疾证号"
          :readonly="!!sourceInfo.canjiCard"
          :class="{ readonly: sourceInfo.canjiCard }"
          placeholder="请输入残疾证号"
          :rules="[{ required: true, message: '请填写' }]"
        />
        <van-field
          name="radio"
          label="是否规培人员"
          :rules="[{ required: true, message: '请选择' }]"
        >
          <template #input>
            <van-radio-group
              v-model="userInfo.isTrainingPersonnel"
              direction="horizontal"
            >
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <sys-dict
          v-model="userInfo.zhengzhiType"
          dict-name="zhengzhiType"
          label="政治面貌"
          required
        />
      </van-cell-group>
      <van-cell-group class="app-card">
        <div class="group-title">紧急联系人</div>
        <van-field
          v-model="userInfo.emergency1"
          label="联系人姓名"
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入' }]"
        />
        <sys-dict
          v-model="userInfo.emergency1Relation"
          dict-name="emergency1Relation"
          label="与本人关系"
          required
        />
        <van-field
          v-model="userInfo.emergency1Mobile"
          label="联系人电话"
          placeholder="请输入"
          type="digit"
          maxlength="11"
          :rules="[{ required: true, message: '请输入' }]"
        />
      </van-cell-group>
      <van-cell-group class="app-card">
        <div class="group-title">地址信息</div>
        <sys-dict
          v-model="userInfo.hukouProvince"
          dict-name="province"
          label="户口省份"
          @changeObject="handleChangeProvice"
          required
        />
        <van-field
          v-model="userInfo.hukouAddress"
          label="户口地址（户口本详细地址）"
          rows="2"
          autosize
          type="textarea"
          :rules="[{ required: true, message: '请输入' }]"
          @click="showToast"
        />
        <van-field
          v-model="userInfo.contactAddress"
          label="通讯地址"
          rows="2"
          autosize
          type="textarea"
          :rules="[{ required: true, message: '请输入' }]"
          @click="showToast"
        />
      </van-cell-group>

      <van-cell-group class="app-card">
        <div class="group-title">电子文件</div>
        <van-cell title="合同拍照">
          <template slot="title">
            <span
              class="custom-title van-icon van-icon-question"
              style="color: #1989fa"
              @click="showHelp('请拍照上传合同第一页，第二页，最后页')"
              >合同拍照</span
            >
          </template>
          <upload
            v-model="userInfo.docHeTong"
            :multiple="true"
            :params="uploadParams"
            type="default"
          ></upload>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="app-card">
        <van-cell title="银行卡拍照">
          <template slot="title">
            <span
              class="custom-title van-icon van-icon-question"
              style="color: #1989fa"
              @click="showHelp('请拍照上传银行卡')"
              >银行卡拍照</span
            >
          </template>
          <upload
            v-model="userInfo.docBankCard"
            :multiple="true"
            :params="uploadParams"
            type="default"
          ></upload>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="app-card">
        <van-cell title="身份证拍照[人像面]">
          <template slot="title">
            <span
              class="custom-title van-icon van-icon-question"
              style="color: #1989fa"
              @click="showHelp('请拍照上传身份证[人像面]')"
              >身份证拍照[人像面]</span
            >
          </template>
          <upload
            v-model="userInfo.docIdCard"
            :multiple="false"
            :params="uploadParams"
            type="idFront"
          ></upload>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="app-card">
        <van-cell title="身份证拍照[国徽面]">
          <template slot="title">
            <span
              class="custom-title van-icon van-icon-question"
              style="color: #1989fa"
              @click="showHelp('请拍照上传身份证[国徽面]')"
              >身份证拍照[国徽面]</span
            >
          </template>
          <upload
            v-model="userInfo.docIdCardBack"
            :multiple="false"
            :params="uploadParams"
            type="idBack"
          ></upload>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="app-card">
        <van-cell title="户口本拍照[首页]">
          <template slot="title">
            <span
              class="custom-title van-icon van-icon-question"
              style="color: #1989fa"
              @click="showHelp('请拍照上传户口本拍照[首页]')"
              >户口本拍照[首页]</span
            >
          </template>
          <upload
            v-model="userInfo.hukoubenHome"
            :multiple="false"
            :params="uploadParams"
            type="default"
          ></upload>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="app-card">
        <van-cell title="户口本拍照[本人页]">
          <template slot="title">
            <span
              class="custom-title van-icon van-icon-question"
              style="color: #1989fa"
              @click="showHelp('请拍照上传户口本拍照[本人页]')"
              >户口本拍照[本人页]</span
            >
          </template>
          <upload
            v-model="userInfo.hukoubenSelf"
            :multiple="false"
            :params="uploadParams"
            type="default"
          ></upload>
        </van-cell>
      </van-cell-group>
      <div style="margin-bottom: 60px; height: 1px; width: 100%"></div>
      <div
        class="fixed-bottom"
        style="
          background: #fff;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-around;
        "
      >
        <van-button style="width: 90%" type="info" round native-type="submit"
          >确认并提交</van-button
        >
      </div>
    </van-form>
    <bind-personnel ref="bindPersonnel" @success="loadData"></bind-personnel>
  </div>
</template>

<style>
.label-offset .van-field__label {
  width: 95px;
}

.van-icon-question::before {
  color: #999;
  font-size: 16px;
}

.van-field__left-icon {
  margin-right: 0;
}

.van-field__control {
  color: #000000;
}

.van-field__label {
  color: #1989fa;
}

.van-field__label {
  width: 110px;
}

/* 	.readonly input {
		color: #999;
	} */
.readonly .van-cell__title,
.readonly .van-field__control {
  color: #999;
}

.van-field__label {
  text-align: left;
}

.ck-wrapper .van-field__label {
  width: 210px;
}

.van-uploader__preview,
.van-uploader__upload {
  margin-top: 8px;
}

.van-uploader__preview-image {
  border: 1px solid #eee;
}
</style>

<script>
import { notifyContent } from "@/utils/sys-dict.js";
import BindPersonnel from "@/components/BindPersonnel";
import mixinLoad from "@/mixin/mixin-load.js";
import SysDict from "@/components/SysDict";
import DateField from "@/components/DateField";
import Upload from "@/components/Upload";

import nativeApi from "@/utils/native-bridge.js";

import { formatDate, toDate } from "@/utils/util.js";
import { userInfoBind, userUpdate, sendCode } from "@/api/user.js";

const fullYear = new Date().getFullYear();
const oneMonthTime = 24 * 3600 * 1000 * 31;

const minWorkDate = new Date();
minWorkDate.setFullYear(fullYear - 70);

const maxWorkDate = new Date();
maxWorkDate.setTime(maxWorkDate.getTime() + oneMonthTime);

const birthDayMin = new Date();
birthDayMin.setFullYear(fullYear - 70);

const birthDayMax = new Date();
birthDayMax.setFullYear(fullYear - 17);

const minPreWorkDate = new Date();
minPreWorkDate.setFullYear(minPreWorkDate.getFullYear() - 10);

const maxPreWorkDate = new Date();
maxPreWorkDate.setTime(maxPreWorkDate.getTime() + oneMonthTime);

const minIdCardDate = new Date();
minIdCardDate.setFullYear(2004);
minIdCardDate.setMonth(0);
minIdCardDate.setDate(1);

export default {
  name: "UserInfoEdit",
  components: {
    SysDict,
    DateField,
    BindPersonnel,
    Upload,
  },
  mixins: [mixinLoad],
  data() {
    return {
      countTimer: null,
      sendCountDown: 0,
      helpTip: null,
      uploadParams: {
        fileType: "img",
        subType: "png,jpeg,jpg",
        fileMaxSize: "10240",
        checkFile: "0",
        serverCheck: "1",
        secrecyLevel: "1",
      },
      minWorkDate: minWorkDate,
      maxWorkDate: maxWorkDate,
      minPreWorkDate: minPreWorkDate,
      maxPreWorkDate: maxPreWorkDate,
      minIdCardDate: minIdCardDate,
      nowDate: new Date(),
      sourceInfo: {},
      userInfo: {
        idCardEndType: undefined,
        idCardStart: undefined,
        idCardEnd: undefined,
        isCanji: "否",
        isTrainingPersonnel: "否",
      },
      birthDayMax: birthDayMax,
      birthDayMin: birthDayMin,
      birthDay: birthDayMax,
    };
  },
  watch: {
    "userInfo.contactAddress": {
      handler(newAddress) {
        this.userInfo.docAddress = newAddress;
      },
      immediate: true,
    },
    "userInfo.idCardEndType": {
      handler(newName) {
        if (newName === "长期") {
          this.userInfo.idCardStart = null;
          this.userInfo.idCardEnd = null;
        }
      },
      immediate: true,
    },
    "userInfo.zhicheng": {
      handler(newName) {
        if (newName === "无") {
          this.userInfo.zhichengCate = null;
        }
      },
      immediate: true,
    },
  },
  computed: {
    weirenClientInfo() {
      return nativeApi.getWeirenClientInfo();
    },
    minIdCardDateEnd() {
      if (this.userInfo.idCardStart) {
        const startDate = this.userInfo.idCardStart.split("-");
        if (startDate.length === 3) {
          let data = new Date();
          data.setFullYear(parseInt(startDate[0]) + 5);
          data.setMonth(parseInt(startDate[1]) - 1);
          data.setDate(startDate[2]);
          return data;
        }
      }
      return this.minIdCardDate;
    },
    maxIdCardDateEnd() {
      if (this.userInfo.idCardStart) {
        const startDate = this.userInfo.idCardStart.split("-");
        if (startDate.length === 3) {
          let data = new Date();
          data.setFullYear(parseInt(startDate[0]) + 30);
          data.setMonth(parseInt(startDate[1]) - 1);
          data.setDate(startDate[2]);
          return data;
        }
      }
      let nowDate = new Date();
      nowDate.setFullYear(nowDate.getFullYear() + 30);
      return nowDate;
    },
    isAgeGreaterThan45() {
      if (this.userInfo.idCard && this.userInfo.idCard.length > 17) {
        // 提取身份证中的出生年份
        const birthYear = parseInt(this.userInfo.idCard.substring(6, 10));
        const currentYear = new Date().getFullYear();
        const age = currentYear - birthYear;
        return age > 45;
      }
      return false;
    },
  },
  methods: {
    showHelp(msg) {
      this.$dialog.alert({
        message: msg,
      });
    },

    /**
     * 显示提示信息，提醒用户填写地址时精确到门牌号。
     * 该方法通过调用 Vue 实例的 $toast 方法来展示提示信息。
     */
     showToast() {
      this.$toast(' 填写的地址请精确到门牌号');
    },

    startCountDown() {
      if (this.countTimer) {
        clearInterval(this.countTimer);
      }
      const _this = this;
      this.sendCountDown = 120;
      this.countTimer = setInterval(function () {
        _this.sendCountDown = _this.sendCountDown - 1;
        if (_this.sendCountDown <= 0) {
          clearInterval(_this.countTimer);
        }
      }, 1000);
    },
    handleChangeProvice(provice) {
      this.userInfo.hukouProvinceCode = provice.value;
    },
    getMobileCode() {
      const loading = this.showLoading();
      sendCode({ mobile: this.userInfo.mobile, type: 30 })
        .then((rep) => {
          this.startCountDown();
          this.showSuccessTip("发送成功");
          loading.clear();
        })
        .catch((rep) => {
          loading.clear();
        });
    },
    handleClickSubmit(isConfirm) {
      this.$dialog
        .confirm({
          title: "确认并提交",
          message: "是否提交信息？",
          confirmButtonText: "确定",
          cancelButtonText: "再想想",
        })
        .then(() => {
          const requrestInfo = Object.assign({}, this.userInfo);
          if (requrestInfo.gangwei == "其他") {
            if (!requrestInfo.gangweiOther) {
              this.showErrorTip("请填写岗位");
              return;
            }
            requrestInfo.gangwei = requrestInfo.gangweiOther;
          }
          if (requrestInfo.isCanji == "是" && !requrestInfo.canjiCard) {
            this.showErrorTip("请填写残疾卡");
            return;
          }
          if (requrestInfo.isCanji == "否") {
            requrestInfo.canjiCard = "";
          }
          if (requrestInfo.idCardEndType == "长期") {
            requrestInfo.idCardEnd = "";
          } else if (requrestInfo.idCardEndType == "固定") {
            if (!requrestInfo.idCardEnd || !requrestInfo.idCardStart) {
              this.showErrorTip("请填写身份证有效期");
              return;
            }
          }

          const loading = this.showLoading();
          userUpdate(requrestInfo)
            .then((rep) => {
              loading.clear();
              this.showSuccessTip(rep.msg);
              this.loadData();
            })
            .catch((rep) => {
              loading.clear();
            });
        });
    },
    loadData() {
      const loading = this.showLoading();
      userInfoBind({})
        .then((rep) => {
          loading.clear();
          const data = rep.data;
          this.sourceInfo = JSON.parse(JSON.stringify(data));
          if (!this.isAgeGreaterThan45) {
            this.userInfo.idCardEndType = "固定";
          }
          this.userInfo = Object.assign(
            {
              contactAddress: undefined,
              zhengzhiType: undefined,
              canbaoType: undefined,
              certImgUrl: undefined,
              idCardEndType: "固定",
              idCardStart: undefined,
              gangweiOther: undefined,
              isCanji: "否",
              isTrainingPersonnel: "否",
              docHeTong: "",
              docIdCard: "",
              docBankCard: "",
              docIdCardBack: "",
              hukoubenHome: "",
              hukoubenSelf: "",
            },
            data
          );
        })
        .catch((rep) => {
          loading.clear();
        });
    },
  },
  created() {
    this.$dialog
      .alert({
        title: "声明",
        message: notifyContent,
        allowHtml: true,
        confirmButtonText: "我确定",
      })
      .then(() => {
        this.loadData();
      });
  },
  destroyed() {
    if (this.countTimer) {
      clearInterval(this.countTimer);
    }
  },
};
</script>
